module.exports = __webpack_public_path__ + "img/kmlogo.4d8a1f39.4d8a1f39.png";